import { Component, Input, ViewEncapsulation } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { ProductListComponent } from 'app/payment/product-list/product-list.component';

export type ProductListDialogData = {
  headlineKey: string;
};

@Component({
  selector: 'app-product-list-dialog',
  templateUrl: './product-list-dialog.component.html',
  standalone: true,
  imports: [TranslocoPipe, ProductListComponent],
  encapsulation: ViewEncapsulation.None,
})
export class ProductListDialogComponent {
  @Input() data: any;
  @Input() close: ((event?: any) => void) | undefined;
}
